/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  accounts: [],
  total:0,
  max:50,
  offset:0,
  sort: 'no',
  order: 'ascending'
};
